// デッキコード（デッキ共有用のハッシュ）の表示・入力ゆれの正規化。
// 採番は worker 側（decks ルート）で行い、フロントは見せ方だけを担当する。

// 4文字ごとにハイフンで区切って読み書きしやすくする（例 ABCD-EFGH-JKMN）
export function formatDeckCode(code: string): string {
  return (code.match(/.{1,4}/g) ?? []).join("-");
}

// 貼り付け時の小文字・空白・ハイフン・紛らわしい文字を吸収する（worker 側と同じ規則）
export function normalizeDeckCode(input: string): string {
  return input
    .toUpperCase()
    .replace(/[^0-9A-Z]/g, "")
    .replace(/[IL]/g, "1")
    .replace(/O/g, "0")
    .replace(/U/g, "V");
}
